import classNames from "clsx";

import { useThemeMode } from "@/../_metronic/partials";

type Props = {
	badge: number;
};

export function Badges({ badge }: Props) {
	const { mode } = useThemeMode();

	const isDarkMode = mode === "dark";

	const getBadgeAttributes = [
		{
			color: isDarkMode ? "badge-danger" : "theme-badge-danger",
			label: "Em processo pré-operatório",
		},
		{
			color: isDarkMode ? "badge-warning" : "theme-badge-warning",
			label: "Aguardando admissão",
		},
		{
			color: isDarkMode ? "badge-primary" : "theme-badge-primary",
			label: "Admitido",
		},
		{
			color: isDarkMode ? "badge-blue" : "theme-badge-blue",
			label: "Em processo operatório",
		},
		{
			color: isDarkMode ? "badge-orange" : "theme-badge-orange",
			label: "Em processo pós-operatório",
		},
		{
			color: isDarkMode ? "badge-purple" : "theme-badge-purple",
			label: "Alta da hospitalização",
		},
		{
			color: isDarkMode ? "badge-success" : "theme-badge-success",
			label: "Completo",
		},
		{
			color: isDarkMode ? "badge-success" : "theme-badge-success",
			label: "Disponível",
		},
		{
			color: "badge-secondary",
			label: "Indisponível",
		},
	];

	return (
		<span
			className={classNames(
				"badge fs-7 w-fit-content my-1 px-3",
				getBadgeAttributes[badge]?.color
			)}
		>
			{getBadgeAttributes[badge]?.label}
		</span>
	);
}
